export const actionTypes = {
  VERIFY_TOKEN: 'VERIFY_TOKEN',
  VERIFY_TOKEN_SUCCESS: 'VERIFY_TOKEN_SUCCESS',
  VERIFY_TOKEN_FAILURE: 'VERIFY_TOKEN_FAILURE',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  AGREED_TO_TERMS: 'AGREED_TO_TERMS',
  UPDATE_BONUS_CHARACTERS: 'UPDATE_BONUS_CHARACTERS',
  UPDATE_REFERRER_ID: 'UPDATE_REFERRER_ID',
  UPDATE_REFERRAL_CODE: 'UPDATE_REFERRAL_CODE',
  REGISTER_REFERRAL: 'REGISTER_REFERRAL',
  UPDATE_REFERRAL_STATS: 'UPDATE_REFERRAL_STATS',
};

const verifyToken = (accessToken) => ({
  type: actionTypes.VERIFY_TOKEN,
  accessToken,
});

const verifyTokenSuccess = (accessToken, user) => ({
  type: actionTypes.VERIFY_TOKEN_SUCCESS,
  accessToken,
  user,
});

const updateUserInfo = (user) => ({
  type: actionTypes.UPDATE_USER_INFO,
  user,
});

const verifyTokenFailure = () => ({ type: actionTypes.VERIFY_TOKEN_FAILURE });

const agreedToTerms = () => ({ type: actionTypes.AGREED_TO_TERMS });

const updateBonusCharacters = (bonusCharacters) => ({
  type: actionTypes.UPDATE_BONUS_CHARACTERS,
  bonusCharacters,
});

const updateReferrerId = (referrerId) => ({
  type: actionTypes.UPDATE_REFERRER_ID,
  referrerId,
});

const updateReferralCode = (referralCode) => ({
  type: actionTypes.UPDATE_REFERRAL_CODE,
  referralCode,
});

const registerReferral = ({ systemReferralCode, joinedAt }) => ({
  type: actionTypes.REGISTER_REFERRAL,
  payload: { systemReferralCode, joinedAt },
});

const updateReferralStats = ({ earnedPoints, spentPoints }) => ({
  type: actionTypes.UPDATE_REFERRAL_STATS,
  payload: { earnedPoints, spentPoints },
});

export {
  verifyToken,
  verifyTokenSuccess,
  verifyTokenFailure,
  updateUserInfo,
  agreedToTerms,
  updateBonusCharacters,
  updateReferrerId,
  updateReferralCode,
  registerReferral,
  updateReferralStats,
};
